// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-segmentation-kpi {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
  margin-top: 4px;
}
.customer-segmentation-kpi__subhead {
  margin: 0 0 20px;
  max-width: 52rem;
  font-size: 13px;
  line-height: 1.55;
  font-weight: 500;
  color: hsl(220, 10%, 40%);
}
.customer-segmentation-kpi__body {
  display: grid;
  grid-template-columns: minmax(240px, 1fr) minmax(320px, 1.05fr);
  gap: 28px 46px;
  align-items: stretch;
}
.customer-segmentation-kpi__chart-block {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
}
.customer-segmentation-kpi__chart-surface {
  --donut-size: 306px;
  --tooltip-width: 220px;
  position: relative;
  width: var(--donut-size);
  min-height: var(--donut-size);
  margin: 0 auto;
  overflow: visible;
  transform: translateY(-20px);
}
.customer-segmentation-kpi__donut-frame {
  position: absolute;
  top: 50%;
  left: 50%;
  width: var(--donut-size);
  height: var(--donut-size);
  transform: translate(-50%, -50%);
}
.customer-segmentation-kpi__donut-frame .recharts-responsive-container {
  position: absolute;
  inset: 0;
}
.customer-segmentation-kpi__cell {
  transition: opacity 0.2s ease;
}
.customer-segmentation-kpi__donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  text-align: center;
  padding: 12%;
}
.customer-segmentation-kpi__donut-total {
  font-size: clamp(1.5rem, 4vw, 1.85rem);
  font-weight: 800;
  letter-spacing: 0;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
}
.customer-segmentation-kpi__donut-total-label {
  margin-top: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: hsl(220, 9%, 42%);
}
.customer-segmentation-kpi__stats {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
  overflow: visible;
}
.customer-segmentation-kpi__stats-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid hsl(220, 14%, 90%);
}
.customer-segmentation-kpi__stats-heading {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.customer-segmentation-kpi__stats-title {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: hsl(220, 12%, 32%);
}
.customer-segmentation-kpi__stats-subtitle {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  color: hsl(220, 9%, 44%);
}
.customer-segmentation-kpi__stats-total-badge {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 6px 12px;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid hsl(220, 14%, 90%);
}
.customer-segmentation-kpi__stats-total-value {
  font-size: 18px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  color: #0f172a;
  line-height: 1.1;
}
.customer-segmentation-kpi__stats-total-label {
  margin-top: 2px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: hsl(220, 9%, 48%);
}
.customer-segmentation-kpi__mix-bar {
  display: flex;
  width: 100%;
  height: 11px;
  border-radius: 999px;
  overflow: hidden;
  gap: 4px;
  box-shadow: 0 0 0 1px hsl(220, 14%, 88%) inset;
  background: hsl(220, 14%, 94%);
}
.customer-segmentation-kpi__mix-bar-seg {
  min-width: 0;
  border-radius: 4px;
  transition: filter 0.2s ease;
}
.customer-segmentation-kpi__mix-bar-seg--new {
  background: linear-gradient(180deg, #4a8aed 0%, #2b74e4 100%);
  min-width: 6px;
}
.customer-segmentation-kpi__mix-bar-seg--returning {
  background: linear-gradient(180deg, #a8dcc4 0%, #5aab87 100%);
  min-width: 6px;
}
.customer-segmentation-kpi__stat-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: visible;
}
.customer-segmentation-kpi__stat-row {
  display: flex;
  align-items: stretch;
  gap: 0;
  min-height: 0;
  border-radius: 11px;
  background: #ffffff;
  border: 1px solid hsl(220, 14%, 90%);
  overflow: visible;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.customer-segmentation-kpi__stat-row:hover {
  border-color: hsl(220, 16%, 82%);
  box-shadow: 0 6px 20px -8px rgba(15, 23, 42, 0.12);
}
.customer-segmentation-kpi__stat-row--emphasis {
  border-color: hsl(220, 14%, 90%);
  box-shadow: none;
}
.customer-segmentation-kpi__stat-rail {
  width: 5px;
  flex-shrink: 0;
  align-self: stretch;
}
.customer-segmentation-kpi__stat-body {
  flex: 1 1;
  min-width: 0;
  padding: 18px 18px 18px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: visible;
}
.customer-segmentation-kpi__stat-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.customer-segmentation-kpi__stat-titles {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  overflow: visible;
}
.customer-segmentation-kpi__stat-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  width: fit-content;
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.2;
  letter-spacing: 0;
}
.customer-segmentation-kpi__stat-label .definition-tooltip__popover {
  width: 360px;
  max-width: min(360px, 100vw - 40px);
}
.customer-segmentation-kpi__stat-sublabel {
  font-size: 12px;
  font-weight: 500;
  color: hsl(220, 9%, 44%);
  line-height: 1.35;
}
.customer-segmentation-kpi__stat-share {
  flex-shrink: 0;
  font-size: 20px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0;
  color: #173f76;
  line-height: 1.1;
  text-align: right;
}
.customer-segmentation-kpi__stat-row--new .customer-segmentation-kpi__stat-share {
  color: #1d4ed8;
}
.customer-segmentation-kpi__stat-row--returning .customer-segmentation-kpi__stat-share {
  color: #166534;
}
.customer-segmentation-kpi__stat-bottom {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding-top: 2px;
  border-top: 0;
}
.customer-segmentation-kpi__stat-count {
  font-size: 18px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: #0f172a;
  line-height: 1;
  letter-spacing: 0;
}
.customer-segmentation-kpi__chart-tooltip {
  padding: 14px 18px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid hsl(220, 14%, 88%);
  box-shadow: 0 4px 6px -1px rgba(15, 23, 42, 0.06), 0 10px 20px -6px rgba(15, 23, 42, 0.12);
  pointer-events: none;
}
.customer-segmentation-kpi__chart-tooltip--floating {
  position: absolute;
  z-index: 3;
  width: var(--tooltip-width);
}
.customer-segmentation-kpi__chart-tooltip--new {
  right: 220px;
  top: 30px;
}
.customer-segmentation-kpi__chart-tooltip--returning {
  right: -104px;
  bottom: 12px;
}
.customer-segmentation-kpi__chart-tooltip--floating::before {
  content: "";
  position: absolute;
  top: 28px;
  width: 18px;
  height: 18px;
  background: #ffffff;
  border: 1px solid hsl(220, 14%, 88%);
  transform: rotate(45deg);
}
.customer-segmentation-kpi__chart-tooltip--new::before {
  right: -9px;
  border-left: 0;
  border-bottom: 0;
}
.customer-segmentation-kpi__chart-tooltip--returning::before {
  left: -9px;
  border-right: 0;
  border-top: 0;
}
.customer-segmentation-kpi__chart-tooltip-label {
  position: relative;
  z-index: 1;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
  color: hsl(220, 9%, 45%);
  margin-bottom: 6px;
}
.customer-segmentation-kpi__chart-tooltip-metric {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 14px;
}
.customer-segmentation-kpi__chart-tooltip-count {
  font-size: 24px;
  font-weight: 800;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}
.customer-segmentation-kpi__chart-tooltip-pct {
  font-size: 18px;
  font-weight: 800;
  color: #2563eb;
  font-variant-numeric: tabular-nums;
}
.customer-segmentation-kpi--empty {
  padding: 28px 20px;
  border-radius: 12px;
  background: hsl(220, 16%, 97%);
  border: 1px dashed hsl(220, 14%, 86%);
  text-align: center;
}
.customer-segmentation-kpi__empty-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  color: hsl(220, 9%, 42%);
  font-weight: 500;
}

@media (max-width: 900px) {
  .customer-segmentation-kpi__body {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  .customer-segmentation-kpi__chart-surface {
    --donut-size: 252px;
    --tooltip-width: 204px;
    width: 252px;
    min-height: 252px;
  }
  .customer-segmentation-kpi__donut-frame {
    top: 50%;
  }
  .customer-segmentation-kpi__chart-tooltip--floating {
    bottom: 26px;
    left: auto;
    transform: none;
  }
  .customer-segmentation-kpi__chart-tooltip--new {
    right: 171px;
    top: 25px;
    bottom: auto;
  }
  .customer-segmentation-kpi__chart-tooltip--returning {
    right: -86px;
    bottom: 5px;
  }
  .customer-segmentation-kpi__chart-tooltip--floating::before {
    display: block;
  }
}
@media (max-width: 520px) {
  .customer-segmentation-kpi__stats-header {
    flex-direction: column;
    align-items: stretch;
  }
  .customer-segmentation-kpi__stats-total-badge {
    flex-direction: row;
    align-items: baseline;
    gap: 8px;
    width: fit-content;
  }
  .customer-segmentation-kpi__stat-top {
    flex-wrap: wrap;
  }
  .customer-segmentation-kpi__stat-share {
    width: 100%;
    text-align: left;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboards/salesProductAnalytics/components/CustomerSegmentationKpi/CustomerSegmentationKpi.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;AACF;AACE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AACJ;AAEE;EACE,aAAA;EACA,+DAAA;EACA,cAAA;EACA,oBAAA;AAAJ;AAGE;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;AADJ;AAIE;EACE,mBAAA;EACA,sBAAA;EAEA,kBAAA;EACA,wBAAA;EACA,6BAAA;EACA,cAAA;EACA,iBAAA;EACA,4BAAA;AAHJ;AAME;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,wBAAA;EACA,yBAAA;EACA,gCAAA;AAJJ;AAOE;EACE,kBAAA;EACA,QAAA;AALJ;AAQE;EACE,6BAAA;AANJ;AASE;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;AAPJ;AAUE;EACE,sCAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kCAAA;EACA,gBAAA;AARJ;AAWE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;AATJ;AAYE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;AAVJ;AAaE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,2CAAA;AAXJ;AAcE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAZJ;AAeE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;AAbJ;AAgBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;AAdJ;AAiBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;AAfJ;AAkBE;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,QAAA;EACA,8CAAA;EACA,8BAAA;AAlBJ;AAqBE;EACE,YAAA;EACA,kBAAA;EACA,4BAAA;AAnBJ;AAsBE;EACE,6DAAA;EACA,cAAA;AApBJ;AAuBE;EACE,6DAAA;EACA,cAAA;AArBJ;AAwBE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,oBAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,iBAAA;EACA,wDACE;AAxBN;AA4BE;EACE,gCAAA;EACA,kDAAA;AA1BJ;AA6BE;EACE,gCAAA;EACA,gBAAA;AA3BJ;AA8BE;EACE,UAAA;EACA,cAAA;EACA,mBAAA;AA5BJ;AA+BE;EACE,SAAA;EACA,YAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AA7BJ;AAgCE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AA9BJ;AAiCE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;AA/BJ;AAkCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAhCJ;AAmCE;EACE,YAAA;EACA,mCAAA;AAjCJ;AAoCE;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;AAlCJ;AAqCE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAnCJ;AAsCE;EACE,cAAA;AApCJ;AAuCE;EACE,cAAA;AArCJ;AAwCE;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;AAtCJ;AAyCE;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;AAvCJ;AA0CE;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,0FACE;EAEF,oBAAA;AA1CJ;AA6CE;EACE,kBAAA;EACA,UAAA;EACA,2BAAA;AA3CJ;AA8CE;EACE,YAAA;EACA,SAAA;AA5CJ;AA+CE;EACE,aAAA;EACA,YAAA;AA7CJ;AAgDE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,wBAAA;AA9CJ;AAiDE;EACE,WAAA;EACA,cAAA;EACA,gBAAA;AA/CJ;AAkDE;EACE,UAAA;EACA,eAAA;EACA,aAAA;AAhDJ;AAmDE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;AAjDJ;AAoDE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;AAlDJ;AAqDE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AAnDJ;AAsDE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AApDJ;AAuDE;EACE,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,qCAAA;EACA,kBAAA;AArDJ;AAwDE;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;AAtDJ;;AA0DA;EACE;IACE,0BAAA;IACA,SAAA;EAvDF;EA0DA;IACE,mBAAA;IACA,sBAAA;IACA,YAAA;IACA,iBAAA;EAxDF;EA2DA;IACE,QAAA;EAzDF;EA4DA;IACE,YAAA;IACA,UAAA;IACA,eAAA;EA1DF;EA6DA;IACE,YAAA;IACA,SAAA;IACA,YAAA;EA3DF;EA8DA;IACE,YAAA;IACA,WAAA;EA5DF;EA+DA;IACE,cAAA;EA7DF;AACF;AAgEA;EACE;IACE,sBAAA;IACA,oBAAA;EA9DF;EAiEA;IACE,mBAAA;IACA,qBAAA;IACA,QAAA;IACA,kBAAA;EA/DF;EAkEA;IACE,eAAA;EAhEF;EAmEA;IACE,WAAA;IACA,gBAAA;IACA,aAAA;IACA,eAAA;IACA,qBAAA;IACA,QAAA;EAjEF;AACF","sourcesContent":[".customer-segmentation-kpi {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-width: 0;\n  margin-top: 4px;\n\n  &__subhead {\n    margin: 0 0 20px;\n    max-width: 52rem;\n    font-size: 13px;\n    line-height: 1.55;\n    font-weight: 500;\n    color: hsl(220 10% 40%);\n  }\n\n  &__body {\n    display: grid;\n    grid-template-columns: minmax(240px, 1fr) minmax(320px, 1.05fr);\n    gap: 28px 46px;\n    align-items: stretch;\n  }\n\n  &__chart-block {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    min-width: 0;\n  }\n\n  &__chart-surface {\n    --donut-size: 306px;\n    --tooltip-width: 220px;\n\n    position: relative;\n    width: var(--donut-size);\n    min-height: var(--donut-size);\n    margin: 0 auto;\n    overflow: visible;\n    transform: translateY(-20px);\n  }\n\n  &__donut-frame {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: var(--donut-size);\n    height: var(--donut-size);\n    transform: translate(-50%, -50%);\n  }\n\n  &__donut-frame .recharts-responsive-container {\n    position: absolute;\n    inset: 0;\n  }\n\n  &__cell {\n    transition: opacity 0.2s ease;\n  }\n\n  &__donut-center {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none;\n    text-align: center;\n    padding: 12%;\n  }\n\n  &__donut-total {\n    font-size: clamp(1.5rem, 4vw, 1.85rem);\n    font-weight: 800;\n    letter-spacing: 0;\n    color: #0f172a;\n    font-variant-numeric: tabular-nums;\n    line-height: 1.1;\n  }\n\n  &__donut-total-label {\n    margin-top: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: hsl(220 9% 42%);\n  }\n\n  &__stats {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    min-width: 0;\n    padding: 0;\n    background: transparent;\n    border: 0;\n    box-shadow: none;\n    overflow: visible;\n  }\n\n  &__stats-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid hsl(220 14% 90%);\n  }\n\n  &__stats-heading {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n  }\n\n  &__stats-title {\n    font-size: 12px;\n    font-weight: 800;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    color: hsl(220 12% 32%);\n  }\n\n  &__stats-subtitle {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.4;\n    color: hsl(220 9% 44%);\n  }\n\n  &__stats-total-badge {\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    padding: 6px 12px;\n    border-radius: 10px;\n    background: #ffffff;\n    border: 1px solid hsl(220 14% 90%);\n  }\n\n  &__stats-total-value {\n    font-size: 18px;\n    font-weight: 800;\n    font-variant-numeric: tabular-nums;\n    letter-spacing: -0.02em;\n    color: #0f172a;\n    line-height: 1.1;\n  }\n\n  &__stats-total-label {\n    margin-top: 2px;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: hsl(220 9% 48%);\n  }\n\n  &__mix-bar {\n    display: flex;\n    width: 100%;\n    height: 11px;\n    border-radius: 999px;\n    overflow: hidden;\n    gap: 4px;\n    box-shadow: 0 0 0 1px hsl(220 14% 88%) inset;\n    background: hsl(220 14% 94%);\n  }\n\n  &__mix-bar-seg {\n    min-width: 0;\n    border-radius: 4px;\n    transition: filter 0.2s ease;\n  }\n\n  &__mix-bar-seg--new {\n    background: linear-gradient(180deg, #4a8aed 0%, #2b74e4 100%);\n    min-width: 6px;\n  }\n\n  &__mix-bar-seg--returning {\n    background: linear-gradient(180deg, #a8dcc4 0%, #5aab87 100%);\n    min-width: 6px;\n  }\n\n  &__stat-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    overflow: visible;\n  }\n\n  &__stat-row {\n    display: flex;\n    align-items: stretch;\n    gap: 0;\n    min-height: 0;\n    border-radius: 11px;\n    background: #ffffff;\n    border: 1px solid hsl(220 14% 90%);\n    overflow: visible;\n    transition:\n      border-color 0.2s ease,\n      box-shadow 0.2s ease;\n  }\n\n  &__stat-row:hover {\n    border-color: hsl(220 16% 82%);\n    box-shadow: 0 6px 20px -8px rgba(15, 23, 42, 0.12);\n  }\n\n  &__stat-row--emphasis {\n    border-color: hsl(220 14% 90%);\n    box-shadow: none;\n  }\n\n  &__stat-rail {\n    width: 5px;\n    flex-shrink: 0;\n    align-self: stretch;\n  }\n\n  &__stat-body {\n    flex: 1;\n    min-width: 0;\n    padding: 18px 18px 18px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    overflow: visible;\n  }\n\n  &__stat-top {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  &__stat-titles {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    min-width: 0;\n    overflow: visible;\n  }\n\n  &__stat-label {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    width: fit-content;\n    font-size: 16px;\n    font-weight: 800;\n    color: #0f172a;\n    line-height: 1.2;\n    letter-spacing: 0;\n  }\n\n  &__stat-label .definition-tooltip__popover {\n    width: 360px;\n    max-width: min(360px, calc(100vw - 40px));\n  }\n\n  &__stat-sublabel {\n    font-size: 12px;\n    font-weight: 500;\n    color: hsl(220 9% 44%);\n    line-height: 1.35;\n  }\n\n  &__stat-share {\n    flex-shrink: 0;\n    font-size: 20px;\n    font-weight: 800;\n    font-variant-numeric: tabular-nums;\n    letter-spacing: 0;\n    color: #173f76;\n    line-height: 1.1;\n    text-align: right;\n  }\n\n  &__stat-row--new &__stat-share {\n    color: #1d4ed8;\n  }\n\n  &__stat-row--returning &__stat-share {\n    color: #166534;\n  }\n\n  &__stat-bottom {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    padding-top: 2px;\n    border-top: 0;\n  }\n\n  &__stat-count {\n    font-size: 18px;\n    font-weight: 800;\n    font-variant-numeric: tabular-nums;\n    color: #0f172a;\n    line-height: 1;\n    letter-spacing: 0;\n  }\n\n  &__chart-tooltip {\n    padding: 14px 18px;\n    border-radius: 8px;\n    background: #ffffff;\n    border: 1px solid hsl(220 14% 88%);\n    box-shadow:\n      0 4px 6px -1px rgba(15, 23, 42, 0.06),\n      0 10px 20px -6px rgba(15, 23, 42, 0.12);\n    pointer-events: none;\n  }\n\n  &__chart-tooltip--floating {\n    position: absolute;\n    z-index: 3;\n    width: var(--tooltip-width);\n  }\n\n  &__chart-tooltip--new {\n    right: 220px;\n    top: 30px;\n  }\n\n  &__chart-tooltip--returning {\n    right: -104px;\n    bottom: 12px;\n  }\n\n  &__chart-tooltip--floating::before {\n    content: \"\";\n    position: absolute;\n    top: 28px;\n    width: 18px;\n    height: 18px;\n    background: #ffffff;\n    border: 1px solid hsl(220 14% 88%);\n    transform: rotate(45deg);\n  }\n\n  &__chart-tooltip--new::before {\n    right: -9px;\n    border-left: 0;\n    border-bottom: 0;\n  }\n\n  &__chart-tooltip--returning::before {\n    left: -9px;\n    border-right: 0;\n    border-top: 0;\n  }\n\n  &__chart-tooltip-label {\n    position: relative;\n    z-index: 1;\n    font-size: 13px;\n    font-weight: 500;\n    letter-spacing: 0;\n    text-transform: none;\n    color: hsl(220 9% 45%);\n    margin-bottom: 6px;\n  }\n\n  &__chart-tooltip-metric {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 14px;\n  }\n\n  &__chart-tooltip-count {\n    font-size: 24px;\n    font-weight: 800;\n    color: #0f172a;\n    font-variant-numeric: tabular-nums;\n  }\n\n  &__chart-tooltip-pct {\n    font-size: 18px;\n    font-weight: 800;\n    color: #2563eb;\n    font-variant-numeric: tabular-nums;\n  }\n\n  &--empty {\n    padding: 28px 20px;\n    border-radius: 12px;\n    background: hsl(220 16% 97%);\n    border: 1px dashed hsl(220 14% 86%);\n    text-align: center;\n  }\n\n  &__empty-text {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.55;\n    color: hsl(220 9% 42%);\n    font-weight: 500;\n  }\n}\n\n@media (max-width: 900px) {\n  .customer-segmentation-kpi__body {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .customer-segmentation-kpi__chart-surface {\n    --donut-size: 252px;\n    --tooltip-width: 204px;\n    width: 252px;\n    min-height: 252px;\n  }\n\n  .customer-segmentation-kpi__donut-frame {\n    top: 50%;\n  }\n\n  .customer-segmentation-kpi__chart-tooltip--floating {\n    bottom: 26px;\n    left: auto;\n    transform: none;\n  }\n\n  .customer-segmentation-kpi__chart-tooltip--new {\n    right: 171px;\n    top: 25px;\n    bottom: auto;\n  }\n\n  .customer-segmentation-kpi__chart-tooltip--returning {\n    right: -86px;\n    bottom: 5px;\n  }\n\n  .customer-segmentation-kpi__chart-tooltip--floating::before {\n    display: block;\n  }\n}\n\n@media (max-width: 520px) {\n  .customer-segmentation-kpi__stats-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .customer-segmentation-kpi__stats-total-badge {\n    flex-direction: row;\n    align-items: baseline;\n    gap: 8px;\n    width: fit-content;\n  }\n\n  .customer-segmentation-kpi__stat-top {\n    flex-wrap: wrap;\n  }\n\n  .customer-segmentation-kpi__stat-share {\n    width: 100%;\n    text-align: left;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
